export const truncateText = (text: string, maxLength: number): string => {
  return text.length > maxLength ? text.slice(0, maxLength) + "..." : text;
};

export const getCheckNumber = (checkNumber: string): string => {
  return truncateText(checkNumber, 100);
};

export const getInvoiceNumber = (invoiceNumber: string): string => {
  return truncateText(invoiceNumber, 100);
};


export const getMessageStringFromQuill = (html: string | null) => {
  if (!html) return "";
  const parser = new DOMParser();
  const doc = parser.parseFromString(html, "text/html");
  const text = doc.body.textContent;
  const trimmed = text?.trim() || "";
  return truncateText(trimmed, 60);
};